import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//Actions
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse'
// To include the default styles
import 'react-rangeslider/lib/index.css'

class SingleSelectDropDown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            questionCount:0,
            answeredQuestion:0,
            horizontal:null,
            optFirstLabel:null,
            optLastLabel:null,
            minValue:null,
            maxValue:null,
            selectedLabel:null,
            isSelect:false,
            responseValue:'',
            selectedOption:null
        };
        this.labels = {};
        this.tempArr = [];
        this.getAllForMultiUser = [];
        this.reviewPage = this.props.questionItemList || [];
        this.isUpdateResponse = false;
        this.dataGuidId = null;
    }

    componentWillReceiveProps(nextProps) {
        if (this.isUpdateResponse !== true) {
            const { getAllItemResponse, items, configuration, getAllItemResponseForMultiple, ratees, rateeKey, putAllForItemCollection, getResPonsesOnLoad } = nextProps;

            if(ratees.length < 2) {
                var nodeList = document.getElementsByName(`SingleDropDown_${items.key}`);
            }
            for (const key in getAllItemResponseForMultiple) {
                this.isUpdateResponse = true;
                items.isHide = false;

                if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                    const elementRes = getAllItemResponseForMultiple[key];

                    if (rateeKey !== undefined && key === rateeKey) {
                        const { itemResponseSets } = elementRes;

                        for (const key in itemResponseSets) {
                            if (Object.hasOwnProperty.call(itemResponseSets, key)) {
                                const elementItemResponseSets = itemResponseSets[key];
                                const tempItemResponseSets = itemResponseSets[key];
                                // tempItemResponseSets.dataCollectionGuid = rateeKey;

                                if (elementItemResponseSets.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                    const itemResponsesForGetAll = elementItemResponseSets.itemResponses;

                                    for (const key in itemResponsesForGetAll) {
                                        if (Object.hasOwnProperty.call(itemResponsesForGetAll, key)) {
                                            const responsesCollection = itemResponsesForGetAll[key];

                                            var responseValue = elementItemResponseSets.itemResponses.length > 0 ? responsesCollection.response : elementItemResponseSets.demographicResponses.length > 0 ? elementItemResponseSets.demographicResponses[0].response : null;

                                            if (this.state.isSelect === false) {
                                                this.setState({
                                                    isSelect:true,
                                                    responseValue:responseValue,
                                                });
                                            }
                                            // this.handleSkipPage(responseValue);
                                            // this.handleDependencyRequired();
                                        }
                                    }

                                    if (tempItemResponseSets.itemResponses.length > 0) {
                                    for (const key in tempItemResponseSets.itemResponses) {
                                        if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                            const temp = tempItemResponseSets.itemResponses[key];
                                            const itemList = this.reviewPage[items.reviewPageKey];

                                            for (const key in itemList) {
                                                if (itemList.hasOwnProperty(key)) {
                                                    const itemRes = itemList[key];
                                                    var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses: [];

                                                    if (this.state.isSelect === false) {
                                                            if(ratees.length < 2) {
                                                                for (const key in nodeList) {
                                                                    if (nodeList.hasOwnProperty(key)) {
                                                                        const element = nodeList[key];
                                                                        if (element.value == responseValue) {
                                                                            element.selected = true;
                                                                            if (ratees.length < 2) {
                                                                                this.handleSkipPage(responseValue);
                                                                                this.handleDependencyPageSkipLogic();
                                                                                if (element.selected) {
                                                                                    this.handleDependencyRequired(element.selected, items.key, element.value);
                                                                                }
                                                                            }														
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                       
                                                        itemRes.isAnswer = temp.response !== null ? true : false;
                                                        itemRes.isRequired = itemRes.requiredIndicator == 2 ? temp.response !== null ? false:true : false;
                                                        itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;

                                                        var itemType = configuration.itemType;
                                                        var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
                                                        //this.handleDependencyRequired(itemRes.key,itemRes.hasDepend);
                                                       processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
                                                       if(ratees.length > 1) {
                                                            getResPonsesOnLoad(items.key, tempItemResponseSets, rateeKey);
                                                        } 
                                                    }
                                                }
                                            }
                                            }
                                        }
                                    } else {
                                        if (items.requiredIndicator == 2) {
                                            items.isRequired = true;
                                        } else {
                                            items.isRequired = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { configuration, ratees } = this.props;

        configuration.map((itm, i) => {
            if (itm.responseValue !== null) {
                this.tempArr[i] = itm.responseValue;
                this.labels[itm.responseValue] = itm.responseValue;
                if (ratees.length < 2) {
                this.handleSkipPage(itm.responseValue);
                this.handleDependencyPageSkipLogic();
            }
            }
            return null;
        });

        if(ratees.length > 1){
            if (this.isUpdateResponse !== true) {
                const { items, activePageKey} = this.props;
                    if (items.requiredIndicator == 2) {
                        const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
                        nextButton.disabled = true;
                        nextButton.classList.add("_PageNextButtonDisable");
                    } 
                }
            }
    }


    handleChange = (event, configuration, rateeKey) => {
        try {
            const { items, handleItemResponse, singleSelectItemConfiguration, itemTempResponses, itemResponseSets, ratees, putAllForItemCollection, dependencies } = this.props;
            const { responseDescription } = configuration;
            const response = event.target.value;
            const filterData = configuration.filter((scaleData) => response == scaleData.response);
            const scaleResponseValue = filterData.length > 0 ? (items.isReversePolarity ? filterData[0].reversePolarityResponseValue :filterData[0].responseValue ):null;

            this.setState({
                isSelect:true,
                responseValue:response,
            });

            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {

                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];
                    var itemKey = itemList[key].key;
                    var hasDepend = itemList[key].hasDepend;

                    if (itemList[key].key === items.key) {
                        itemList[key].isAnswer = response !== "" ? true : false;
                        // itemList[key].isRequired = response == "" ? true : false;

                        if (itemList[key].requiredIndicator == 2) {
                            itemList[key].isRequired = itemList[key].isAnswer == true ? false : true;
                        } else {
                            itemList[key].isRequired = false
                        }

                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {
                                    this.dataGuidId = rateeKey;

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType"     : singleSelectItemConfiguration.itemType,
                                        "buttonGroup"  : null,
                                        "sequence"     : 1,
                                        "isNa"         : itemList[key].isNA,
                                        "response"     : response == "" ? null : response,
                                        "responseValue": response == "" ? null : scaleResponseValue,
                                        "openEnd"      : null,
                                        "responseDescription":responseDescription,
                                    }];

                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].itemResponses[itemKey];
                                    var itemType = singleSelectItemConfiguration.itemType;
                                    this.handleSkipPage(scaleResponseValue);
                                    processItemResponse(itemKey, responseSet, itemResponses, itemType, this.dataGuidId, putAllForItemCollection,"onChange");
                                }
                            }
                        }
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                    this.setState({itemResponses:itemList[key].itemResponses[itemList[key].key]});
                }
            }
            
            handleItemResponse(items.key, itemTempResponses, "itemChange", this.dataGuidId);
            this.handleDependencyRequired(itemKey, hasDepend);
            this.handleDependencyPageSkipLogic();
        } catch (error) {
            console.log("Exception: while responding question answer in single select response:_", error);
        }
    }

    handleSkipPage = (tempResponseValue) => {
        try {
            const { dependencies, items } = this.props;
            var responseValue = tempResponseValue;
            var nodeList = document.getElementsByName(`SingleDropDown_${items.key}`);

            for (const key in dependencies) {
                if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key];

                    element.filter((dep) => {
                        if (dep.dependsOnKey === items.key) {

                            var skipDiv = document.getElementById("survey-item-block_" + dep.key);
                            var skipDivOld = document.getElementsByName("survey-item-block");

                            var conditionString = "";
                            element.map((item, i) => {
                                return conditionString += `( ${item.response} ${item.booleanOperator} ${tempResponseValue} ) ${item.dependsOnConditionalOperator !== null ? item.dependsOnConditionalOperator : ""}`
                            });

                            var newStr = conditionString.length > 15 ? conditionString.substr(0, conditionString.length - 1) : conditionString;
                            var result = newStr.split(') |').join(")");
                            var newCondition = result.split('|').join("||");

                            if (newCondition !== '' && eval(newCondition)) {
                                for (const key in skipDivOld) {
                                    if (Object.hasOwnProperty.call(skipDivOld, key)) {
                                        const dataId = skipDivOld[key].getAttribute('data-id');

                                        if (dataId == dep.key) {
                                            skipDivOld[key].classList.remove('_Unblock');
                                            skipDivOld[key].classList.add('_block');
                                            skipDivOld[key].classList.add(`_block_${items.key}_${responseValue}`);
                                        }
                                    }
                                }
                            } else {
                                for (const key in nodeList) {
                                    if (Object.hasOwnProperty.call(nodeList, key)) {
                                        const element = nodeList[key];
                                            if (!element.selected) {
                                                var newEl = document.getElementsByClassName(`_block_${items.key}_${element.value}`)[0];
                                    if (newEl !== undefined) {
                                        newEl.classList.remove('_block');
                                        newEl.classList.remove(`_block_${items.key}_${element.value}`);
                                        newEl.classList.add('_Unblock');
                            	}
                                            }
                                    }
                                }
                                if (this.state.isSelect) {
                            } else {
                                skipDiv.style.display = "none";
                            }
                        }
                        }
                    })
                }
            }
        } catch (error) {
            console.log("Exceptions: while skipping item and page", error.message);
        }
    }


    handleDependencyPageSkipLogic = () => {
        var timeOut = setTimeout(() => {
            const { items, nextPageKey, dependencies, pageList } = this.props;
    
            for (const key in dependencies) {
                if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key]
    
                    element.filter((dep) => {
                        if (dep.dependsOnKey === items.key) {
    
                            pageList.filter((page) => {
                                const { items } = page;
                                page.checkOnNextButtonClick = false;
    
                                items.filter((itm) => {
                                    if (itm.hasDepend == true) {
                                        page.checkOnNextButtonClick = true;
                                    }
                                });
                            })
                        }
                    })
                }
            }
            clearTimeout(timeOut)
        }, 0);
    }
    handleDependencyRequired = (itemKey, hasDepend) => {
        try {
            var test = setTimeout(() => {
            const { pageList, nextPageKey } = this.props;

                var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
                var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);
                const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];

                for (const key in pageList) {
                    if (Object.hasOwnProperty.call(pageList, key)) {
                        if (pageList[key].key == nextPageKey) {
                            const tempItems = pageList[key].items;

                    for (const key in tempItems) {
                        if (Object.hasOwnProperty.call(tempItems, key)) {
                            const element = tempItems[key];

                                for (const depKey in _blockElement) {
                                    if (Object.hasOwnProperty.call(_blockElement, depKey)) {
                                        const dataId = _blockElement[depKey].getAttribute('data-id');

                                        if (element.key === dataId) {
                                            element.isHide = false;
                                        }
                                    }
                                }

                                for (const bKey in _unBlockElement) {
                                    if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
                                        const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

                                        if (element.key === dataIdUnblock) {
                                            element.isHide = true;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if(hasDepend) {
                            for( const depKey in this.props.dependencies) {
                                this.props.dependencies[depKey].map((dep) => {
                                    if(itemKey == dep.key){
                                        this.props.handleDependentItem(itemKey,dep.response,null)
                                    }
                                });
                            }


                            }
                        }
                    }
                }

                clearTimeout(test);
            }, 0);

        } catch (error) {

        }
    }
    render() {
        const { configuration, suppressLabel, rateeKey, items } = this.props;

        return (
            <Fragment>
                {/* <Row> */}
                    {/* <Col md="10"> */}
                        { suppressLabel ? null : <span className=''></span> }
                        <select
                            className={`_SingleSelectDropDown`}
                            // name={`SingleDropDown_${items.key}`}
                            id={`SingleSelectGroup_${rateeKey}`}
                            onChange={(event) => this.handleChange(event, configuration, rateeKey)}
                        >
                            <option value="">Select Option</option>
                            {
                                configuration && configuration.map((responseConfiguration, i) => {
                                    return <option 
                                                value={responseConfiguration.response} 
                                                selected={this.state.responseValue === responseConfiguration.response} 
                                                // className={`SingleSelectDropDown_${items.key}`}
                                                className={`SingleDropDown_${items.key}`}
                                                name={`SingleDropDown_${items.key}`}
                                            >
                                                    {responseConfiguration.responseDescription}
                                            </option>
                                })
                            }
                        </select>
                    {/* </Col> */}
                {/* </Row> */}
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount:state.survey.answeredQuestionCount,
    getAllItemResponse:state.survey.getAllItemResponse,
    getAllItemResponseForMultiple:state.survey.getAllItemResponseForMultiple
});

export default connect(mapStateToProps)(SingleSelectDropDown);
